import React from "react";

import FormInput from "../Form/form-input";

// import CustomButton from '../custom-button/custom-button.component'

// import { auth, signInWithGoogle } from '../../firebase/firebase.utils'

// import './_login.scss'

class Login extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      email: "",
      password: "",
    };
  }

  handleSubmit = async (event) => {
    event.preventDefault();
    console.log("SUBMITTED");
    // const { email, password } = this.state;

    // try {
    //     await auth.signInWithEmailAndPassword(email, password);
    //     this.setState({ email: '', password: '' });
    // } catch (error) {
    //     console.log(error);
    // }
  };

  handleChange = (event) => {
    const { value, name } = event.target;

    this.setState({ [name]: value });
  };

  render() {
    return (
      <div className="sign-in">
        <h2 className="title">I already have an account</h2>
        <span>Sign in with your email and password</span>

        <form onSubmit={this.handleSubmit}>
          <FormInput
            name="email"
            type="email"
            handleChange={this.handleChange}
            value={this.state.email}
            label="email"
            required
          />
          <FormInput
            name="password"
            type="password"
            value={this.state.password}
            handleChange={this.handleChange}
            label="password"
            required
          />
          <div className="buttons">
            <button className="custom-btn btn-4" type="submit">
              {" "}
              Sign in{" "}
            </button>
            {/* <button
              classname="custom-btn btn-4"
              type="button"
              onClick={console.log("SUBMITTING GOGGLE")}
              isGoogleSignIn
            >
              Sign in with Google
            </button> */}
          </div>
        </form>
      </div>
    );
  }
}

export default Login;
